<h1 mat-dialog-title class="pt-2 text-center"> Création d'évènement</h1>
<div mat-dialog-content class="p-0">
    <div class="container no-gutters">

        <!-- <div class="row m-0">
            <mat-form-field class="col">
                <mat-select placeholder="préleveur" [(ngModel)]="Model.Sampler" [compareWith]="compareUserWith">
                    @for (user of UserList; track user) {
                    <mat-option [value]="user">
                        {{ user.FirstName }} {{ user.LastName }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div> -->
        <!-- (selectionChange)="getSelectedTechnicien($event);" -->
        <div class="row m-0">
            <div class="col">
                <mat-form-field class="w-100">
                    <mat-select placeholder="Préleveur" [(ngModel)]="SelectedTechnicianList" multiple [compareWith]="compareUserWith" [disabled]="this.Model.Code">
                        @for (tech of UserList; track tech; let i = $index) {
                        <mat-option [value]="tech"  >
                            {{ tech.FirstName }} {{ tech.LastName }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row m-0">
            <mat-form-field class="col">
                <mat-select placeholder="type" [(ngModel)]="Model.Type">
                    @for (type of EventTypeList; track type; let i = $index) {
                    <mat-option [value]="i + 2">
                        {{ type }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row m-0">
            <mat-form-field class="col">
                <input matInput placeholder="Début" [matDatepicker]="picker1" [(ngModel)]="From" (focus)="picker1.open()" (ngModelChange)="dateChanged()">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="col">
                <input matInput placeholder="Heure" [format]="24" [ngxMatTimepicker]="timepicker1" [value]="FromTime" readonly>
                <ngx-mat-timepicker #timepicker1 (timeSet)="fromtimeSet($event)"></ngx-mat-timepicker>
            </mat-form-field>
        </div>

        <div class="row m-0">
            <mat-form-field class="col">
                <input matInput placeholder="Fin" [matDatepicker]="picker2" [(ngModel)]="To" (focus)="picker2.open()">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="col">
                <input matInput placeholder="Heure" [format]="24" [ngxMatTimepicker]="timepicker2" [value]="ToTime" readonly>
                <ngx-mat-timepicker #timepicker2 (timeSet)="totimeSet($event)"></ngx-mat-timepicker>
            </mat-form-field>
        </div>
        <div class="row m-0 ">
            <mat-form-field class="col">
                <mat-label>Titre</mat-label>
                <input matInput [(ngModel)]="Model.Titre" placeholder="Titre" required [formControl]="ValidMaxLength">
                <mat-hint align="end">{{Model.Titre?.length || 0}}/{{MAX_LENGTH}}</mat-hint>
                @if (ValidMaxLength.hasError('maxlength')) {
                <mat-error>
                    Titre trop long
                </mat-error>
                }
            </mat-form-field>
        </div>
        <div class="row m-0 ">
            <mat-form-field class="col">
                <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="3" [(ngModel)]="Model.Description"
                          placeholder="Description"></textarea>
            </mat-form-field>
        </div>
        <div class="row m-1">
            <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
                Annuler
            </button>
            <button appPreventDoubleClick class="col ms-1" mat-raised-button color="primary" (throttledClick)="finish()" [disabled]="!canFinish()">
                Ajouter
            </button>
        </div>
    </div>
</div>